import { render, staticRenderFns } from "./SummerBannerPhone.vue?vue&type=template&id=a8f13234&"
import script from "./SummerBannerPhone.vue?vue&type=script&lang=js&"
export * from "./SummerBannerPhone.vue?vue&type=script&lang=js&"
import style0 from "./SummerBannerPhone.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fbanner-phone&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports